import { CubeIcon, DoubleArrowRightIcon, GlobeIcon, MixIcon } from '@radix-ui/react-icons';
import { Box, Card, FeatureIcon, Flex, Grid, IconPanel, Text } from '@workos-inc/design-system';
import NextLink from 'next/link';
import { NavigationMenu } from 'radix-ui';
import { ApiReferenceIcon } from 'src/icons/api-reference-icon';
import { EventsIcon } from 'src/icons/events-icon';
const FEATURE_ITEMS = [{
  title: 'AuthKit',
  description: 'Full-fledged auth platform',
  route: '/authkit',
  icon: 'user-management'
}, {
  title: 'Single Sign-On',
  description: 'Integrate with any IdP',
  route: '/sso',
  icon: 'sso'
}, {
  title: 'Directory Sync',
  description: 'Manage user directories',
  route: '/directory-sync',
  icon: 'directory-sync'
}, {
  title: 'Admin Portal',
  description: 'Self-serve onboarding',
  route: '/admin-portal',
  icon: 'admin-portal'
}, {
  title: 'Audit Logs',
  description: 'Ingest and export events',
  route: '/audit-logs',
  icon: 'audit-logs'
}, {
  title: 'Domain Verification',
  description: 'Confirm domain ownership',
  route: '/domain-verification',
  icon: 'domain-verification'
}, {
  title: 'Role-Based Access Control',
  description: 'Manage access through roles and permissions',
  route: '/rbac',
  icon: 'rbac'
}, {
  title: 'Fine-Grained Authorization',
  description: 'Implement authorization in your application',
  route: '/fga',
  icon: 'fga'
}, {
  title: 'Vault',
  description: 'Encrypt, store, and control access to sensitive data',
  route: '/vault',
  icon: 'vault'
}, {
  title: 'Pipes',
  description: 'Connect third-party accounts to your application',
  route: '/pipes',
  icon: 'pipes'
}, {
  title: 'Feature Flags',
  description: 'Control rollout of new features in your application.',
  route: '/feature-flags',
  icon: 'feature-flags'
}, {
  title: 'Widgets',
  description: 'Complete functionality for common enterprise app workflows.',
  route: '/widgets',
  icon: 'widgets'
}] as const;
const RESOURCE_ITEMS = [{
  title: 'API Reference',
  description: 'All methods and endpoints',
  route: '/reference',
  icon: ApiReferenceIcon
}, {
  title: 'Integrations',
  description: 'Third-party service guides',
  route: '/integrations',
  icon: MixIcon
}, {
  title: 'Events and webhooks',
  description: 'Respond to WorkOS activity',
  route: '/events',
  icon: EventsIcon
}, {
  title: 'Migrate to WorkOS',
  description: 'Switch from another provider',
  route: '/migrate',
  icon: DoubleArrowRightIcon
}, {
  title: 'SDKs',
  description: 'Official repos and changelogs',
  route: '/sdks',
  icon: CubeIcon
}, {
  title: 'Custom domains',
  description: 'Bring your own domains to WorkOS',
  route: '/custom-domains',
  icon: GlobeIcon
}];
export const NavigationItems = () => <NavigationMenu.Root orientation="vertical" data-sentry-element="NavigationMenu.Root" data-sentry-component="NavigationItems" data-sentry-source-file="navigation-items.tsx">
    <NavigationMenu.List asChild data-sentry-element="NavigationMenu.List" data-sentry-source-file="navigation-items.tsx">
      <Grid columns={{
      md: '3'
    }} gapX={{
      md: '5'
    }} gapY={{
      initial: '7',
      md: '0'
    }} data-sentry-element="Grid" data-sentry-source-file="navigation-items.tsx">
        <Box style={{
        gridColumn: '1 / 3'
      }} data-sentry-element="Box" data-sentry-source-file="navigation-items.tsx">
          <Text as="div" mb="4" size="3" trim="start" weight="bold" data-sentry-element="Text" data-sentry-source-file="navigation-items.tsx">
            Integrate a feature
          </Text>

          <Grid columns={{
          md: '2'
        }} gap="5" data-sentry-element="Grid" data-sentry-source-file="navigation-items.tsx">
            {FEATURE_ITEMS.map((item, i) => <Card key={i} asChild size="1" variant="ghost">
                <NavigationMenu.Link asChild>
                  <NextLink href={item.route}>
                    <Flex align="center" gap="3">
                      <FeatureIcon feature={item.icon} size="1" />
                      <Flex direction="column">
                        <Text size="2" weight="bold">
                          {item.title}
                        </Text>
                        <Text size="2">{item.description}</Text>
                      </Flex>
                    </Flex>
                  </NextLink>
                </NavigationMenu.Link>
              </Card>)}
          </Grid>
        </Box>

        <Box data-sentry-element="Box" data-sentry-source-file="navigation-items.tsx">
          <Text as="div" mb="4" size="3" trim="start" weight="bold" data-sentry-element="Text" data-sentry-source-file="navigation-items.tsx">
            Explore the platform
          </Text>

          <Grid columns="1" gap="5" data-sentry-element="Grid" data-sentry-source-file="navigation-items.tsx">
            {RESOURCE_ITEMS.map((item, i) => {
            const Icon = item.icon;
            return <Card key={i} asChild size="1" variant="ghost">
                  <NavigationMenu.Link asChild>
                    <NextLink href={item.route}>
                      <Flex align="center" gap="3">
                        <IconPanel size="3">
                          <Icon />
                        </IconPanel>
                        <Flex direction="column">
                          <Text size="2" weight="bold">
                            {item.title}
                          </Text>
                          <Text size="2">{item.description}</Text>
                        </Flex>
                      </Flex>
                    </NextLink>
                  </NavigationMenu.Link>
                </Card>;
          })}
          </Grid>
        </Box>
      </Grid>
    </NavigationMenu.List>
  </NavigationMenu.Root>;